module.exports = { 
      attributes: {"title":"Internal tournament evaluation september 2023","categories":["shogi"],"tags":["shogi"],"language":"en","section":"shogi","slug":"internalgames202309"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = function render() { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-body"},[_c('p',[_vm._v("On 14.09.2023 our september internal house league took place.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',[_c('data-table',{attrs:{"csvUrl":"/csv/hausliga/2023/202309.csv","hasRowNumbers":false,"columnLabels":['Platz', 'Name', 'Rang', 'Ligamodifier', 'Round', '1', '2', '3', '4', '5', '6', '7', 'Points'],"boldedColumns":[0],"sortColumn":0}})],1),_vm._v(" "),_vm._m(1)]) };
            this.$options.staticRenderFns = [function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Tournament evaluation")])]) },function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Fritz receives +1,"),_c('br'),_vm._v("\nMarcel receives -1,"),_c('br'),_vm._v("\nLeague modifier for the upcoming tournaments.")]) }];
          }
        }
      },
     }